import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { spellingUSUKData, getDataForDifficulty } from '../courses/data/vocabulary/spellingUSUK';

export default function SpellingUSUKTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : spellingUSUKData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
